import React, { useState } from 'react';
import { Box, Button, Typography, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useParams, useNavigate } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';

const DeleteConfirmation = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const [loading, setLoading] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);

  const handleDelete = async () => {
    console.log('Deleting product with ID:', productId);
    const token = localStorage.getItem('token');

    if (!token) {
      console.error('Token is missing. Please log in.');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`https://daradservice.azurewebsites.net/api/P2PProducts/delete-product?productId=${productId}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });

      if (response.ok) {
        setSuccessModalOpen(true);
      } else {
        setErrorModalOpen(true);
      }
    } catch (error) {
      console.error('Error deleting product:', error);
      setErrorModalOpen(true);
    }
    setLoading(false);
  };

  const handleCloseSuccessModal = () => {
    setSuccessModalOpen(false);
    navigate('/product/ptwop');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        p: isDesktop ? 4 : 2,
        borderRadius: 3,
        border: '1px solid #ddd',
        boxShadow: 1,
        maxWidth: isDesktop ? 500 : '90%',
        mx: 'auto',
        my: isDesktop ? 5 : 3,
        textAlign: 'center',
      }}
    >
      <DeleteIcon sx={{ color: 'red', fontSize: isDesktop ? 60 : 40 }} />
      <Typography fontWeight="bold" fontSize={isDesktop ? '1.5rem' : '1.2rem'}>
        Confirm Deletion
      </Typography>
      <Typography fontSize={isDesktop ? '1rem' : '0.9rem'}>
        Are you sure you want to delete this product? This action cannot be undone.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, width: '100%', flexDirection: isDesktop ? 'row' : 'column' }}>
      <Button
  sx={{
    bgcolor: '#F3F4F6',
    color: '#555556',
    borderRadius: '9999px',
    width: isDesktop ? '50%' : '100%',
    padding: isDesktop ? '12px 24px' : '10px 20px',
    fontSize: isDesktop ? '1rem' : '0.9rem',
  }}
  disabled={loading}
  onClick={() => navigate('/product/ptwop')}
>
  Cancel
</Button>

        <Button
          onClick={handleDelete}
          sx={{
            bgcolor: '#FE0000',
            color: '#FFFFFF',
            borderRadius: '9999px',
            width: isDesktop ? '50%' : '100%',
            padding: isDesktop ? '12px 24px' : '10px 20px',
            fontSize: isDesktop ? '1rem' : '0.9rem',
          }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} sx={{ color: '#FFFFFF' }} /> : 'Yes, Delete'}
        </Button>
      </Box>

      {/* Success Modal */}
      <Dialog open={successModalOpen} onClose={handleCloseSuccessModal} fullWidth maxWidth="sm">
        <DialogTitle>Success!</DialogTitle>
        <DialogContent>
          <Typography variant="body1" color="textSecondary">
            Product deleted successfully!
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSuccessModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Error Modal */}
      <Dialog open={errorModalOpen} onClose={() => setErrorModalOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Error!</DialogTitle>
        <DialogContent>
          <Typography variant="body1" color="textSecondary">
            Something went wrong. Please try again.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorModalOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DeleteConfirmation;
